import { QuoteHeader } from '@shared/schema';
// Zeilen-Mathematik kommt aus der EINEN gemeinsamen Quelle (Client + Server + Export).
import { roundMoney, toSafeNumber, getLineNet } from '@shared/quote-totals';

export {
  getLineBaseNet,
  getLineDiscountAmount,
  getLineNet,
  getLineNet as getLineNetAfterDiscount, // Alt-Name, an vielen Call-Sites verwendet
  isBedarfsposition,
  isAlternativposition,
  isExcludedFromMainSum,
  computeQuoteTotals,
  toSafeNumber,
} from '@shared/quote-totals';
export type { QuoteTotals } from '@shared/quote-totals';

export type LineDiscountType = 'percent' | 'absolute';

export function normalizeVatRate(rate: unknown): 0 | 7 | 19 {
  const numericRate = Math.round(toSafeNumber(rate, 19));
  if (numericRate === 0 || numericRate === 7 || numericRate === 19) {
    return numericRate;
  }
  return 19;
}

export function getVatRateFromHeader(header?: Partial<QuoteHeader> | null): 0 | 7 | 19 {
  return normalizeVatRate(header?.mwstSatz);
}

/** Hauptsummen-Netto (alle Zeilen NACH Zeilenrabatt). Achtung: schließt Bedarfs-/
 * Alternativpositionen NICHT aus — für die Auftragssumme computeQuoteTotals().netMain. */
export function getQuoteNetAfterLineDiscount(items: Array<Record<string, unknown>>): number {
  return roundMoney(items.reduce((sum, item) => sum + getLineNet(item as any), 0));
}
